/**
 * @generated SignedSource<<b76dc6089a59959485d9934126c469a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleBeforeYouGoWidget$data = {
  readonly " $fragmentSpreads": FragmentRefs<"beforeYouGoActionWidgetContent">;
  readonly " $fragmentType": "articleBeforeYouGoWidget";
};
export type articleBeforeYouGoWidget$key = {
  readonly " $data"?: articleBeforeYouGoWidget$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleBeforeYouGoWidget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleBeforeYouGoWidget",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "beforeYouGoActionWidgetContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "e135abbda8a9e46fb65125c36bbd5a48";

export default node;
